export const HOST = 'https://cms.vintageacquisitions.com/nc/vintage_acquisitions_cxdc/api/v1';
export const BE_HOST = 'https://api.vintageacquisitions.com/b/api';

// export const BE_HOST = 'http://localhost:3000/b/api';
